export default {
  'consent:page-hidden:text':
    'Diese Seite ist nicht vollständig sichtbar, weil du keine Zustimmung für funktionale Cookies erteilt hast.',
  'consent:page-hidden:button': 'Cookie-Einstellungen öffnen',
};
